export default __webpack_public_path__ + "static/media/Image1.add8148d.png";